"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = SsoDeck;
exports.getHostEnv = getHostEnv;
var _react = _interopRequireWildcard(require("react"));
var _ssoDeck = _interopRequireDefault(require("auth-react/sso-deck"));
var _traffic = require("@site/pattern-library-utils/traffic");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _spinner = _interopRequireDefault(require("../spinner"));
var _core = require("@linaria/core");
var _useIsServerSideRender = _interopRequireDefault(require("@site/pattern-library-utils/hooks/useIsServerSideRender"));
var _base = require("@site/pattern-library-utils/base.functions");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/* eslint-disable no-console */

"pl-s1xko84g";

/**
 * Create Encoded Path and Lid query combination
 *
 * @param {string} path Path
 * @param {string} lid Lid
 * @returns {string} Encoded Path and Lid
 */
function createPath(path, lid) {
  let decodedPath = decodeURIComponent(path);
  let decodedLid = decodeURIComponent(lid);

  // add a '?' to path if not present and account for other potential query parameters
  decodedPath = decodedPath.includes('?') ? decodedPath : decodedPath + '?';
  decodedLid = 'lid=' + decodedLid;
  decodedPath = decodedPath.endsWith('?') ? decodedPath : decodedPath + '&';
  return encodeURIComponent(decodedPath + decodedLid);
}
function getHostEnv(host) {
  const env = (0, _base.getDefaultEnv)();
  const prefix = env === 'prod' ? '' : `${env}-`;
  if (host.includes(prefix)) {
    return host;
  }
  return `${prefix}${host}`;
}
function SsoDeck({
  app = 'www',
  path = '/',
  lid = '',
  port = '',
  plid = '1',
  realm = 'idp',
  host = 'godaddy.com',
  pageToLoad = '/landing',
  pageToLoadParams = {},
  pageToLoadData = {}
}) {
  const [isLoading, setIsLoading] = (0, _react.useState)(true);
  const fullPath = lid ? createPath(path, lid) : path;
  const isServerSideRender = (0, _useIsServerSideRender.default)();
  const envHost = (0, _react.useMemo)(() => getHostEnv(host), [host]);
  const componentProps = {
    on_load: () => {
      setIsLoading(false);
    },
    on_auth: event => {
      if (typeof window !== 'undefined' && event?.data?.redirect_url) {
        window.location = event.data.redirect_url;
      }
    },
    on_error: error => {
      console.log('SSO Deck error', error);
    },
    traffic_func: (eventDescription, eventId) => {
      (0, _traffic.logImpression)(eventId);
    },
    host: envHost,
    consuming_app: app,
    consuming_path: fullPath,
    consuming_port: port,
    page_to_load_params: {
      realm: realm,
      app: app,
      path: fullPath,
      plid: plid,
      lid: lid || '',
      ...(pageToLoadParams || {})
    },
    page_to_load: pageToLoad,
    page_to_load_data: pageToLoadData
  };
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, isLoading && /*#__PURE__*/_react.default.createElement(_spinner.default, {
    size: "lg",
    className: "sso-spinner"
  }), !isServerSideRender && /*#__PURE__*/_react.default.createElement(_ssoDeck.default, componentProps));
}
SsoDeck.propTypes = {
  app: _propTypes.default.string,
  path: _propTypes.default.string,
  lid: _propTypes.default.string,
  port: _propTypes.default.string,
  plid: _propTypes.default.string,
  realm: _propTypes.default.string,
  host: _propTypes.default.string,
  pageToLoad: _propTypes.default.string,
  pageToLoadParams: _propTypes.default.shape({
    hide_social: _propTypes.default.bool,
    enableCheckoutLite: _propTypes.default.bool
  }),
  pageToLoadData: _propTypes.default.object
};